import { render, staticRenderFns } from "./ModelLabel.vue?vue&type=template&id=83fbe60a&scoped=true"
import script from "./ModelLabel.vue?vue&type=script&lang=js"
export * from "./ModelLabel.vue?vue&type=script&lang=js"
import style0 from "./ModelLabel.vue?vue&type=style&index=0&id=83fbe60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fbe60a",
  null
  
)

export default component.exports